var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRussiaOstatkiSladki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: 22.701,
    cy: 22.769,
    r: 17.705,
    gradientUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#fcc325",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "#eba625",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#e39925"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 28.316,
    cy: 34.401,
    r: 3.692,
    gradientUnits: "userSpaceOnUse",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#f8b827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#f8b827",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 22.307,
    cy: 21.937,
    r: 13.023,
    gradientUnits: "userSpaceOnUse",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#933c11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#933c11",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 22.527,
    cy: 22.159,
    r: 7.056,
    gradientUnits: "userSpaceOnUse",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#d2763d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#d2763d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#d2763d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 23.166,
    cy: 22.221,
    r: 5.289,
    gradientUnits: "userSpaceOnUse",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#d2763d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#d2763d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 21.627,
    cy: 21.724,
    r: 7.007,
    gradientUnits: "userSpaceOnUse",
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#752604",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#752604"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 29.814,
    cy: 14.931,
    r: 4.14,
    gradientUnits: "userSpaceOnUse",
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b45b1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#ba631e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#cb7a21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#e39925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#e59c25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "#eba725"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#f6b925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    stopColor: "#fcc325"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 29.814,
    cy: 14.931,
    r: 2.742,
    gradientUnits: "userSpaceOnUse",
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b45b1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#b45b1d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 29.814,
    cy: 14.931,
    r: 4.14,
    gradientUnits: "userSpaceOnUse",
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#fcc325",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#fcc325"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 21.309,
    cy: 21.197,
    r: 12.823,
    gradientUnits: "userSpaceOnUse",
    id: "m"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#de4088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    stopColor: "#de4088"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 21.322,
    cy: 21.173,
    r: 12.811,
    gradientUnits: "userSpaceOnUse",
    id: "n"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.342,
    stopColor: "#de4088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#e25094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#f69dcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    stopColor: "#de4088"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 21.594,
    cy: 21.543,
    r: 8.539,
    gradientUnits: "userSpaceOnUse",
    id: "o"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.257,
    stopColor: "#c52e7c",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#c52e7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    stopColor: "#c52e7c",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 21.594,
    cy: 21.543,
    r: 7.395,
    gradientUnits: "userSpaceOnUse",
    id: "p"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#a81062",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#a81062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    stopColor: "#a81062",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 21.14,
    cy: 19.387,
    r: 12.832,
    gradientUnits: "userSpaceOnUse",
    id: "q"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#f6bdd9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#f6bdd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957,
    stopColor: "#f6bdd9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 19.387,
    cy: 28.547,
    r: 6.426,
    gradientUnits: "userSpaceOnUse",
    id: "r"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#f6aad7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6aad7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 24.922,
    cy: 31.368,
    r: 12.855,
    gradientUnits: "userSpaceOnUse",
    id: "s"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c52e7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#c52e7c",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 13.757,
    cy: 36.435,
    r: 12.823,
    gradientUnits: "userSpaceOnUse",
    id: "t"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#db3580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#db3580",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 19.299,
    cy: 20.517,
    r: 10.017,
    gradientUnits: "userSpaceOnUse",
    id: "u"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.097,
    stopColor: "#db3580",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#db3580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#db3580",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 33.282,
    y1: 10.758,
    x2: 29.676,
    y2: 14.769,
    gradientUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.049,
    stopColor: "#c05a19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#c05a19",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 21.425,
    y1: 16.673,
    x2: 21.799,
    y2: 24.088,
    gradientUnits: "userSpaceOnUse",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#752604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#752604",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 30.489,
    y1: 11.558,
    x2: 31.051,
    y2: 19.711,
    gradientUnits: "userSpaceOnUse",
    id: "l"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b45b1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#b45b1d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 24.411,
    y1: 21.102,
    x2: 34.312,
    y2: 20.341,
    gradientUnits: "userSpaceOnUse",
    id: "v"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e94990",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e94990"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "none",
    strokeMiterlimit: 10,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M162.284 109.498s-6.783-6.262-16.233-6.183c-9.434.08-22.969 7.812-27.771 22.883-4.803 15.07-4.1 31.106 1.466 38.918 5.566 7.812 19.803 5.836 19.803 5.836l56.931-26.362s8.966 2.767 14.783 8.76c5.8 5.994 7.266 13.41 7.032 17.048-.234 3.622-5.723 31.391-37.907 50.905-32.184 19.514-82.77 21.476-113.41-6.31-30.64-27.785-32.153-84.446-27.054-105.448 5.114-20.984 21.285-53.91 61.265-76.08 39.997-22.172 64.977-12.778 81.85-.633 16.856 12.16 43.006 32.687 32.028 40.104-10.993 7.417-52.783 36.562-52.783 36.562z",
    fill: "#d26920",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.974 19.35s-.972-.897-2.325-.886c-1.352.011-3.29 1.12-3.978 3.278-.688 2.158-.587 4.455.21 5.574.797 1.119 2.836.836 2.836.836l8.155-3.776s1.284.396 2.117 1.255c.83.858 1.04 1.92 1.007 2.441-.034.52-.82 4.496-5.43 7.291-4.61 2.796-11.854 3.076-16.243-.903-4.389-3.98-4.605-12.095-3.875-15.104.733-3.005 3.049-7.72 8.775-10.897 5.729-3.175 9.307-1.83 11.723-.09 2.415 1.742 6.16 4.682 4.588 5.744-1.575 1.062-7.56 5.237-7.56 5.237z",
    fill: "url(#a)",
    fillRule: "nonzero",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.974 19.35s-.972-.897-2.325-.886c-1.352.011-3.29 1.12-3.978 3.278-.688 2.158-.587 4.455.21 5.574.797 1.119 2.836.836 2.836.836l8.155-3.776s1.284.396 2.117 1.255c.83.858 1.04 1.92 1.007 2.441-.034.52-.82 4.496-5.43 7.291-4.61 2.796-11.854 3.076-16.243-.903-4.389-3.98-4.605-12.095-3.875-15.104.733-3.005 3.049-7.72 8.775-10.897 5.729-3.175 9.307-1.83 11.723-.09 2.415 1.742 6.16 4.682 4.588 5.744-1.575 1.062-7.56 5.237-7.56 5.237z",
    fill: "url(#b)",
    fillRule: "nonzero",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.825 225.118s5.332-2.689 13.379-6.943c8.046-4.254 5.8-3.384 8.592-8.049 2.791-4.665 14.549-9.71 18.79-13.584 4.24-3.875 10.68-10.105 12.927-13.015 2.245-2.926 1.933.87.702 5.44-1.248 4.57-.859 10.422-13.535 20.526-12.693 10.106-26.307 15.388-35.273 17.68-8.982 2.293-7.672-.553-5.582-2.055z",
    fill: "#f1a22e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.532 219.836s6.58-2.925 7.89-7.338c1.31-4.427 4.101-5.281 12.85-10.817 8.747-5.519 14.392-10.974 13.144-8.049-1.232 2.926-4.959 11.054-16.014 18.313-11.056 7.259-19.491 10.801-17.87 7.891z",
    fill: "#f8b827",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.974 19.35s-.972-.897-2.325-.886c-1.352.011-3.29 1.12-3.978 3.278-.688 2.158-.587 4.455.21 5.574.797 1.119 2.836.836 2.836.836l8.155-3.776s1.284.396 2.117 1.255c.83.858 1.04 1.92 1.007 2.441-.034.52-.82 4.496-5.43 7.291-4.61 2.796-11.854 3.076-16.243-.903-4.389-3.98-4.605-12.095-3.875-15.104.733-3.005 3.049-7.72 8.775-10.897 5.729-3.175 9.307-1.83 11.723-.09 2.415 1.742 6.16 4.682 4.588 5.744-1.575 1.062-7.56 5.237-7.56 5.237z",
    fill: "url(#c)",
    fillRule: "nonzero",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.974 19.35s-.972-.897-2.325-.886c-1.352.011-3.29 1.12-3.978 3.278-.688 2.158-.587 4.455.21 5.574.797 1.119 2.836.836 2.836.836l8.155-3.776s1.284.396 2.117 1.255c.83.858 1.04 1.92 1.007 2.441-.034.52-.82 4.496-5.43 7.291-4.61 2.796-11.854 3.076-16.243-.903-4.389-3.98-4.605-12.095-3.875-15.104.733-3.005 3.049-7.72 8.775-10.897 5.729-3.175 9.307-1.83 11.723-.09 2.415 1.742 6.16 4.682 4.588 5.744-1.575 1.062-7.56 5.237-7.56 5.237z",
    fill: "url(#d)",
    fillRule: "nonzero",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.715 105.008c-3.712-13.742-13.722-32.34-40.839-32.924-43.162-.95-54.764 55.728-42.242 87.783 10.385 26.552 51.021 26.552 66.255 5.393l-12.334 5.71s-14.236 1.976-19.803-5.836c-5.567-7.813-6.269-23.832-1.466-38.919 4.803-15.07 18.338-22.82 27.771-22.883 9.434-.079 16.233 6.184 16.233 6.184s2.48-1.771 6.425-4.508z",
    fill: "#7b290b",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.907 18.682c-.531-1.97-1.965-4.632-5.849-4.718-6.182-.136-7.846 7.982-6.05 12.573 1.487 3.803 7.307 3.803 9.487.774l-1.766.818s-2.04.283-2.837-.836c-.797-1.119-.898-3.413-.21-5.574.688-2.159 2.627-3.266 3.978-3.277 1.351-.012 2.323.885 2.323.885l.924-.645z",
    fill: "url(#e)",
    fillRule: "nonzero",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.917 18.677c-.532-1.97-1.965-4.632-5.85-4.718-6.181-.136-7.845 7.982-6.05 12.573 1.488 3.803 7.308 3.803 9.488.775l-1.767.817s-2.039.283-2.836-.836c-.797-1.119-.898-3.413-.21-5.574.688-2.158 2.627-3.266 3.978-3.277 1.35-.012 2.322.885 2.322.885l.925-.645z",
    fill: "url(#f)",
    fillRule: "nonzero",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.907 18.682c-.531-1.97-1.965-4.632-5.849-4.718-6.182-.136-7.846 7.982-6.05 12.573 1.487 3.803 7.307 3.803 9.487.774l-1.766.818s-2.04.283-2.837-.836c-.797-1.119-.898-3.413-.21-5.574.688-2.159 2.627-3.266 3.978-3.277 1.351-.012 2.323.885 2.323.885l.924-.645z",
    fill: "url(#g)",
    fillRule: "nonzero",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.917 18.677c-.532-1.97-1.965-4.632-5.85-4.718-6.181-.136-7.845 7.982-6.05 12.573 1.488 3.803 7.308 3.803 9.488.775l-1.767.817s-2.039.283-2.836-.836c-.797-1.119-.898-3.413-.21-5.574.688-2.158 2.627-3.266 3.978-3.277 1.35-.012 2.322.885 2.322.885l.925-.645z",
    fill: "url(#h)",
    fillRule: "nonzero",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.93 19.38s.688.872 2.616.283c1.927-.587 4.415-2.713 5.175-4.702.76-1.991-.255-2.634-1.12-2.736-.864-.102-3.18.294-5.007 2.102-1.829 1.81-2.483 3.957-1.663 5.053z",
    fill: "url(#i)",
    fillRule: "nonzero",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.93 19.38s.688.872 2.616.283c1.927-.587 4.415-2.713 5.175-4.702.76-1.991-.255-2.634-1.12-2.736-.864-.102-3.18.294-5.007 2.102-1.829 1.81-2.483 3.957-1.663 5.053z",
    fill: "url(#j)",
    fillRule: "nonzero",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.93 19.38s.688.872 2.616.283c1.927-.587 4.415-2.713 5.175-4.702.76-1.991-.255-2.634-1.12-2.736-.864-.102-3.18.294-5.007 2.102-1.829 1.81-2.483 3.957-1.663 5.053z",
    fill: "url(#k)",
    fillRule: "nonzero",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.93 19.38s.688.872 2.616.283c1.927-.587 4.415-2.713 5.175-4.702.76-1.991-.255-2.634-1.12-2.736-.864-.102-3.18.294-5.007 2.102-1.829 1.81-2.483 3.957-1.663 5.053z",
    fill: "url(#l)",
    fillRule: "nonzero",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.735 12.029a1 1 0 0 0 .107.179c.005.032-.078.174-.303.274-.228.1-2.087.66-3.333 1.835-1.246 1.175-1.86 2.086-2.17 3.019-.311.933-.333 1.171-.434 1.187-.098.016-.31-.188-.587-.634-.277-.447-1.418-1.663-2.526-1.871-1.108-.209-4.4.412-5.707 3.76-1.308 3.345-.531 5.925 1.198 7.302 1.728 1.38 4.214.508 4.868.193.655-.317 2.066-1.713 2.305-1.989.24-.276.45-.802 1.025-1.119.577-.317 2.426-.645 3.679-.39 1.253.254 1.811.587 2.028.99.216.401.426 1.149.272 1.758-.154.611-.471.809-.764 1.024-.294.215-1.201.813-2.354 2.192-1.152 1.38-1.728 2.21-2.14 2.634-.408.424-1.036.707-1.433.7-.4-.006-.431-.01-.592.041-.16.05-.348.095-.326.204.022.109.217.623-.143 1.137s-1.722.802-2.6.503c-.875-.3-1.28-.605-1.71-.718-.434-.113-1.142.17-1.691.249-.55.08-2 .027-2.653-.26a16.657 16.657 0 0 1-2.002-1.08c-.4-.266-2.054-1.426-2.82-2.472-.764-1.046-2.133-3.504-2.4-5.699-.265-2.192-.142-5.767.921-8.23 1.063-2.465 2.649-4.207 4.599-5.813 1.95-1.606 5.23-3.504 8.187-3.606 2.96-.102 5.575.689 7.248 2.127 1.67 1.434 2.251 2.573 2.251 2.573z",
    fill: "url(#m)",
    fillRule: "nonzero",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.747 12.005s.105.147.107.178c.003.032-.078.175-.303.275-.228.1-2.087.659-3.333 1.834-1.246 1.176-1.862 2.086-2.173 3.02-.31.933-.333 1.17-.43 1.186-.1.016-.311-.188-.588-.634-.277-.446-1.418-1.662-2.526-1.87-1.108-.21-4.4.412-5.707 3.76-1.306 3.347-.531 5.922 1.198 7.302 1.728 1.38 4.216.51 4.868.192.655-.317 2.066-1.712 2.305-1.99.24-.277.45-.802 1.025-1.12.577-.317 2.426-.643 3.679-.39 1.253.254 1.811.59 2.028.99.216.401.426 1.149.27 1.758-.154.61-.471.809-.764 1.024-.292.215-1.201.813-2.354 2.193-1.152 1.379-1.728 2.21-2.14 2.634-.408.423-1.036.707-1.433.7-.4-.005-.434-.012-.592.04-.161.053-.349.096-.328.204.022.107.216.621-.143 1.135-.36.514-1.722.804-2.598.503-.875-.299-1.28-.605-1.713-.718-.431-.113-1.141.17-1.69.25-.55.078-2 .026-2.654-.261a16.42 16.42 0 0 1-1.999-1.08c-.4-.266-2.055-1.425-2.82-2.472-.767-1.046-2.131-3.502-2.4-5.697-.265-2.192-.142-5.766.92-8.23 1.066-2.463 2.65-4.205 4.6-5.81 1.95-1.606 5.23-3.504 8.187-3.606 2.96-.102 5.575.688 7.248 2.124 1.672 1.436 2.253 2.576 2.253 2.576z",
    fill: "url(#n)",
    fillRule: "nonzero",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.747 12.005s.105.147.107.178c.003.032-.078.175-.303.275-.228.1-2.087.659-3.333 1.834-1.246 1.176-1.862 2.086-2.173 3.02-.31.933-.333 1.17-.43 1.186-.1.016-.311-.188-.588-.634-.277-.446-1.418-1.662-2.526-1.87-1.108-.21-4.4.412-5.707 3.76-1.306 3.347-.531 5.922 1.198 7.302 1.728 1.38 4.216.51 4.868.192.655-.317 2.066-1.712 2.305-1.99.24-.277.45-.802 1.025-1.12.577-.317 2.426-.643 3.679-.39 1.253.254 1.811.59 2.028.99.216.401.426 1.149.27 1.758-.154.61-.471.809-.764 1.024-.292.215-1.201.813-2.354 2.193-1.152 1.379-1.728 2.21-2.14 2.634-.408.423-1.036.707-1.433.7-.4-.005-.434-.012-.592.04-.161.053-.349.096-.328.204.022.107.216.621-.143 1.135-.36.514-1.722.804-2.598.503-.875-.299-1.28-.605-1.713-.718-.431-.113-1.141.17-1.69.25-.55.078-2 .026-2.654-.261a16.42 16.42 0 0 1-1.999-1.08c-.4-.266-2.055-1.425-2.82-2.472-.767-1.046-2.131-3.502-2.4-5.697-.265-2.192-.142-5.766.92-8.23 1.066-2.463 2.65-4.205 4.6-5.81 1.95-1.606 5.23-3.504 8.187-3.606 2.96-.102 5.575.688 7.248 2.124 1.672 1.436 2.253 2.576 2.253 2.576z",
    fill: "url(#o)",
    fillRule: "nonzero",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.747 12.005s.105.147.107.178c.003.032-.078.175-.303.275-.228.1-2.087.659-3.333 1.834-1.246 1.176-1.862 2.086-2.173 3.02-.31.933-.333 1.17-.43 1.186-.1.016-.311-.188-.588-.634-.277-.446-1.418-1.662-2.526-1.87-1.108-.21-4.4.412-5.707 3.76-1.306 3.347-.531 5.922 1.198 7.302 1.728 1.38 4.216.51 4.868.192.655-.317 2.066-1.712 2.305-1.99.24-.277.45-.802 1.025-1.12.577-.317 2.426-.643 3.679-.39 1.253.254 1.811.59 2.028.99.216.401.426 1.149.27 1.758-.154.61-.471.809-.764 1.024-.292.215-1.201.813-2.354 2.193-1.152 1.379-1.728 2.21-2.14 2.634-.408.423-1.036.707-1.433.7-.4-.005-.434-.012-.592.04-.161.053-.349.096-.328.204.022.107.216.621-.143 1.135-.36.514-1.722.804-2.598.503-.875-.299-1.28-.605-1.713-.718-.431-.113-1.141.17-1.69.25-.55.078-2 .026-2.654-.261a16.42 16.42 0 0 1-1.999-1.08c-.4-.266-2.055-1.425-2.82-2.472-.767-1.046-2.131-3.502-2.4-5.697-.265-2.192-.142-5.766.92-8.23 1.066-2.463 2.65-4.205 4.6-5.81 1.95-1.606 5.23-3.504 8.187-3.606 2.96-.102 5.575.688 7.248 2.124 1.672 1.436 2.253 2.576 2.253 2.576z",
    fill: "url(#p)",
    fillRule: "nonzero",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.747 12.005s.105.147.107.178c.003.032-.078.175-.303.275-.228.1-2.087.659-3.333 1.834-1.246 1.176-1.862 2.086-2.173 3.02-.31.933-.333 1.17-.43 1.186-.1.016-.311-.188-.588-.634-.277-.446-1.418-1.662-2.526-1.87-1.108-.21-4.4.412-5.707 3.76-1.306 3.347-.531 5.922 1.198 7.302 1.728 1.38 4.216.51 4.868.192.655-.317 2.066-1.712 2.305-1.99.24-.277.45-.802 1.025-1.12.577-.317 2.426-.643 3.679-.39 1.253.254 1.811.59 2.028.99.216.401.426 1.149.27 1.758-.154.61-.471.809-.764 1.024-.292.215-1.201.813-2.354 2.193-1.152 1.379-1.728 2.21-2.14 2.634-.408.423-1.036.707-1.433.7-.4-.005-.434-.012-.592.04-.161.053-.349.096-.328.204.022.107.216.621-.143 1.135-.36.514-1.722.804-2.598.503-.875-.299-1.28-.605-1.713-.718-.431-.113-1.141.17-1.69.25-.55.078-2 .026-2.654-.261a16.42 16.42 0 0 1-1.999-1.08c-.4-.266-2.055-1.425-2.82-2.472-.767-1.046-2.131-3.502-2.4-5.697-.265-2.192-.142-5.766.92-8.23 1.066-2.463 2.65-4.205 4.6-5.81 1.95-1.606 5.23-3.504 8.187-3.606 2.96-.102 5.575.688 7.248 2.124 1.672 1.436 2.253 2.576 2.253 2.576z",
    fill: "url(#q)",
    fillRule: "nonzero",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.942 28.17s-.043 2.519-6.796 2.666c-3.721.082-4.733-2.174-4.856-3.119-.094-.734.768-2.052 2.265-.944 1.496 1.107 3.72 2.052 6.148 1.395 2.43-.655 3.563-1.23 3.239.002z",
    fill: "url(#r)",
    fillRule: "evenodd",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.747 12.005s.105.147.107.178c.003.032-.078.175-.303.275-.228.1-2.087.659-3.333 1.834-1.246 1.176-1.862 2.086-2.173 3.02-.31.933-.333 1.17-.43 1.186-.1.016-.311-.188-.588-.634-.277-.446-1.418-1.662-2.526-1.87-1.108-.21-4.4.412-5.707 3.76-1.306 3.347-.531 5.922 1.198 7.302 1.728 1.38 4.216.51 4.868.192.655-.317 2.066-1.712 2.305-1.99.24-.277.45-.802 1.025-1.12.577-.317 2.426-.643 3.679-.39 1.253.254 1.811.59 2.028.99.216.401.426 1.149.27 1.758-.154.61-.471.809-.764 1.024-.292.215-1.201.813-2.354 2.193-1.152 1.379-1.728 2.21-2.14 2.634-.408.423-1.036.707-1.433.7-.4-.005-.434-.012-.592.04-.161.053-.349.096-.328.204.022.107.216.621-.143 1.135-.36.514-1.722.804-2.598.503-.875-.299-1.28-.605-1.713-.718-.431-.113-1.141.17-1.69.25-.55.078-2 .026-2.654-.261a16.42 16.42 0 0 1-1.999-1.08c-.4-.266-2.055-1.425-2.82-2.472-.767-1.046-2.131-3.502-2.4-5.697-.265-2.192-.142-5.766.92-8.23 1.066-2.463 2.65-4.205 4.6-5.81 1.95-1.606 5.23-3.504 8.187-3.606 2.96-.102 5.575.688 7.248 2.124 1.672 1.436 2.253 2.576 2.253 2.576z",
    fill: "url(#s)",
    fillRule: "nonzero",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.747 12.005s.105.147.107.178c.003.032-.078.175-.303.275-.228.1-2.087.659-3.333 1.834-1.246 1.176-1.862 2.086-2.173 3.02-.31.933-.333 1.17-.43 1.186-.1.016-.311-.188-.588-.634-.277-.446-1.418-1.662-2.526-1.87-1.108-.21-4.4.412-5.707 3.76-1.306 3.347-.531 5.922 1.198 7.302 1.728 1.38 4.216.51 4.868.192.655-.317 2.066-1.712 2.305-1.99.24-.277.45-.802 1.025-1.12.577-.317 2.426-.643 3.679-.39 1.253.254 1.811.59 2.028.99.216.401.426 1.149.27 1.758-.154.61-.471.809-.764 1.024-.292.215-1.201.813-2.354 2.193-1.152 1.379-1.728 2.21-2.14 2.634-.408.423-1.036.707-1.433.7-.4-.005-.434-.012-.592.04-.161.053-.349.096-.328.204.022.107.216.621-.143 1.135-.36.514-1.722.804-2.598.503-.875-.299-1.28-.605-1.713-.718-.431-.113-1.141.17-1.69.25-.55.078-2 .026-2.654-.261a16.42 16.42 0 0 1-1.999-1.08c-.4-.266-2.055-1.425-2.82-2.472-.767-1.046-2.131-3.502-2.4-5.697-.265-2.192-.142-5.766.92-8.23 1.066-2.463 2.65-4.205 4.6-5.81 1.95-1.606 5.23-3.504 8.187-3.606 2.96-.102 5.575.688 7.248 2.124 1.672 1.436 2.253 2.576 2.253 2.576z",
    fill: "url(#t)",
    fillRule: "nonzero",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.747 12.005s.105.147.107.178c.003.032-.078.175-.303.275-.228.1-2.087.659-3.333 1.834-1.246 1.176-1.862 2.086-2.173 3.02-.31.933-.333 1.17-.43 1.186-.1.016-.311-.188-.588-.634-.277-.446-1.418-1.662-2.526-1.87-1.108-.21-4.4.412-5.707 3.76-1.306 3.347-.531 5.922 1.198 7.302 1.728 1.38 4.216.51 4.868.192.655-.317 2.066-1.712 2.305-1.99.24-.277.45-.802 1.025-1.12.577-.317 2.426-.643 3.679-.39 1.253.254 1.811.59 2.028.99.216.401.426 1.149.27 1.758-.154.61-.471.809-.764 1.024-.292.215-1.201.813-2.354 2.193-1.152 1.379-1.728 2.21-2.14 2.634-.408.423-1.036.707-1.433.7-.4-.005-.434-.012-.592.04-.161.053-.349.096-.328.204.022.107.216.621-.143 1.135-.36.514-1.722.804-2.598.503-.875-.299-1.28-.605-1.713-.718-.431-.113-1.141.17-1.69.25-.55.078-2 .026-2.654-.261a16.42 16.42 0 0 1-1.999-1.08c-.4-.266-2.055-1.425-2.82-2.472-.767-1.046-2.131-3.502-2.4-5.697-.265-2.192-.142-5.766.92-8.23 1.066-2.463 2.65-4.205 4.6-5.81 1.95-1.606 5.23-3.504 8.187-3.606 2.96-.102 5.575.688 7.248 2.124 1.672 1.436 2.253 2.576 2.253 2.576z",
    fill: "url(#u)",
    fillRule: "nonzero",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.747 12.005s.105.147.107.178c.003.032-.078.175-.303.275-.228.1-2.087.659-3.333 1.834-1.246 1.176-1.862 2.086-2.173 3.02-.31.933-.333 1.17-.43 1.186-.1.016-.311-.188-.588-.634-.277-.446-1.418-1.662-2.526-1.87-1.108-.21-4.4.412-5.707 3.76-1.306 3.347-.531 5.922 1.198 7.302 1.728 1.38 4.216.51 4.868.192.655-.317 2.066-1.712 2.305-1.99.24-.277.45-.802 1.025-1.12.577-.317 2.426-.643 3.679-.39 1.253.254 1.811.59 2.028.99.216.401.426 1.149.27 1.758-.154.61-.471.809-.764 1.024-.292.215-1.201.813-2.354 2.193-1.152 1.379-1.728 2.21-2.14 2.634-.408.423-1.036.707-1.433.7-.4-.005-.434-.012-.592.04-.161.053-.349.096-.328.204.022.107.216.621-.143 1.135-.36.514-1.722.804-2.598.503-.875-.299-1.28-.605-1.713-.718-.431-.113-1.141.17-1.69.25-.55.078-2 .026-2.654-.261a16.42 16.42 0 0 1-1.999-1.08c-.4-.266-2.055-1.425-2.82-2.472-.767-1.046-2.131-3.502-2.4-5.697-.265-2.192-.142-5.766.92-8.23 1.066-2.463 2.65-4.205 4.6-5.81 1.95-1.606 5.23-3.504 8.187-3.606 2.96-.102 5.575.688 7.248 2.124 1.672 1.436 2.253 2.576 2.253 2.576z",
    fill: "url(#v)",
    fillRule: "nonzero",
    transform: "translate(-26.04 -25.598) scale(6.98182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.974 195.752s31.482-.316 45.485-4.507c14.003-4.19 24.98-13.726 30.095-13.647 5.099.079 5.895 6.5 1.778 12.16-4.117 5.662-38.407 19.215-58.257 16.526-19.85-2.688-18.493-2.704-20.66-4.918-2.153-2.214-.063-6.088 1.559-5.614z",
    fill: "#c62e82",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.01 204.853s1.466-4.112 6.113-4.745c4.646-.632 5.41.475 9.434-2.53 4.023-3.005 5.566-6.389 4.911-5.756-.655.632-5.956 4.618-9.558 5.409-3.602.79-7.579 1.85-9.512 4.111-1.934 2.246-2.51 4.333-1.388 3.51z",
    fill: "#e377a9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.96 198.915c.094-.016 2.48-.791 5.302-1.677 2.822-.886 3.556-1.597 2.978-.79-.577.806-2.947 2.72-5.738 3.02-2.807.3-3.056-.396-2.542-.553z",
    fill: "#fbe0eb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.418 197.965s14.658 9.868 26.805 10.453c12.147.585 12.147-1.771 19.694-.838 7.532.949 7.625 3.954 12.225 5.092 4.6 1.139 7.204.395 6.768.158-.421-.237-4.6-2.055-9.636-4.697-5.037-2.64-8.749-3.4-17.746-2.135-9.013 1.265-24.684-2.166-30.204-4.744-5.535-2.546-7.828-4.111-7.906-3.289z",
    fill: "#e881af",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.738 212.373s-5.302-4.982-12.802-6.088c-7.5-1.108-13.145 1.739-13.145 1.739s9.746-2.45 14.19-.474c4.444 1.976 5.972 3.89 8.436 4.696 2.448.807 3.945.997 3.321.127z",
    fill: "#f5bdd5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.827 27.345s19.258-.237 37.752 12.477c18.493 12.715 19.943 21.508 19.538 21.634-.39.126-2.838-.158-8.17 2.751-5.334 2.926-4.102 1.74-1.311-4.095 2.791-5.836-7.485-15.213-20.567-22.488-13.083-7.274-4.663-3.89-27.242-10.279z",
    fill: "#f997d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.792 170.302s-10.012 8.967-16.25 18.63c-6.236 9.661-11.944 13.489-15.155 14.2-3.213.712-4.913.19-7.548.902-2.635.711-2.51 3.005-2.589 1.455-.077-1.55.625-2.72 6.612-3.907 5.988-1.185 9.98-2.688 15.095-10.137 5.099-7.463 11.336-15.671 15.125-18.865 3.774-3.195 5.208-2.99 4.71-2.278z",
    fill: "#f588ca",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.714 200.37s9.403 7.512 18.026 10.928c8.623 3.416 18.65 3.147 24.404 2.008 5.769-1.139 7.5-1.06 5.644-1.976-1.855-.902-11.757 1.818-21.55-.111-9.777-1.93-20.926-8.492-23.701-10.454-2.776-1.96-3.665-1.186-2.823-.395z",
    fill: "#f589cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.945 213.63s5.458 4.459 16.357 3.905c10.915-.553 12.023-6.594 11.18-8.84-.857-2.245-.732 3.796-7.032 6.231-6.3 2.451-14.782-.048-17.48-1.265-2.713-1.218-3.882-1.265-3.025-.032z",
    fill: "#f587c8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.867 203.882s14.408 2.736 36.207-1.265c21.8-4.001 29.94-14.36 29.472-16.099-.468-1.74-7.423-.553-12.85 3.147-5.41 3.716-26.383 10.106-38.904 10.422-12.538.331-17.184-.855-13.925 3.795z",
    fill: "#c22a78",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.86 153.29s4.725 21.397 14.16 31.502c9.434 10.105 15 11.212 14.782 7.654-.234-3.558-4.413-13.03-8.67-17.838-4.257-4.808-8.358-10.96-12.069-17.206-3.695-6.262-8.405-8.16-8.202-4.111z",
    fill: "#f5b0d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.91 156.533s4.866 8.445 7.657 12.398c2.79 3.954 3.181 7.022.156 6.468-3.025-.554-9.512-15.94-9.902-18.55-.39-2.609 1.154-1.66 2.09-.316z",
    fill: "#fadff3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.81 37.448s-25.043 5.36-49.196 32.988C44.459 98.079 44.85 135.637 44.787 141.33c-.062 5.693 4.023 10.422 6.658-7.1 2.635-17.522 1.7-34.112 19.18-59.366 17.496-25.256 40.699-31.881 45.486-33.779 4.802-1.898 5.426-3.954 1.7-3.637z",
    fill: "#f5b7d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.896 108.534s4.49-16.89 17.713-24.465c13.24-7.574 22.284-9.552 32.575-6.23 10.292 3.32 13.847 12.16 15.547 12.24 1.7.078 1.387-2.894-.468-5.598-1.84-2.705-5.832-5.978-6.799-7.26-.982-1.28-1.076-5.597-7.656-7.337-6.58-1.74-16.405-2.451-26.228 1.74-9.824 4.19-11.523 8.524-11.836 10.026-.31 1.502-1.543 3.48-3.867 6.152-2.323 2.672-6.798 8.365-9.434 14.516-2.62 6.152-2.713 8.05-1.699 8.446.998.379 2.152-2.23 2.152-2.23z",
    fill: "#da70ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.453 82.81s8.28-6.152 18.603-7.18c10.322-1.028 16.17.553 18.727 2.135 2.557 1.582 6.846 5.915 8.436 7.416 1.59 1.503 1.824.349 1.248-.995-.578-1.345-5.037-5.093-6.223-6.31-1.2-1.218-.31-3.796-4.522-5.962-4.225-2.167-7.656-3.748-18.415-2.167-10.76 1.582-17.979 7.86-19.07 9.156-1.077 1.298-.89 2.404-1.357 3.638-.468 1.218-3.197 4.428-4.803 5.677-1.606 1.25-2.12 3.147-.81 2.325 1.294-.839 5.394-5.567 8.186-7.733z",
    fill: "#eca7d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.409 80.755s2.276-4.428 8.201-6.784c5.926-2.373 13.067-4.033 20.537-3.321 7.485.727 10.136 3.858 11.134 4.934.997 1.075-.421 1.77-1.014 1.66-.577-.127-7.578-3.906-18.603-2.214-11.025 1.692-17.98 6.832-19.304 7.306-1.31.474-.951-1.581-.951-1.581z",
    fill: "#fbd6f9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.69 151.048s2.79-6.357 9.246-8.334c6.456-1.977 19.492-.743 24.45.316 4.96 1.06 7.033 5.599 4.678 6.2-2.354.584-24.013 3.004-31.592 4.017-7.594 1.027-7.858-.618-6.782-2.2z",
    fill: "#eb7aae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.93 147.49s7.813-1.028 16.482-1.661c8.67-.633 11.524-.522 11.29-1.218-.234-.711-10.76-3.178-18.104-2.214-9.122 1.202-12.46 6.2-9.668 5.092z",
    fill: "#eb9ec4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.034 166.192s9.59 6.388 16.717 8.207c7.11 1.818 10.977 2.53 9.59 3.716-1.389 1.186-8.67 3.874-21.192-2.689-12.552-6.546-8.451-11.528-5.115-9.234z",
    fill: "#f6aad7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.907 155.534s-1.527 2.135-.685 4.539c.826 2.403 2.556 2.498 7.078 2.64 4.523.143 11.197-.237 12.382-.854 1.185-.6 2.323-2.973 2.089-5.123-.234-2.151-2.37-2.847-3.212-2.926-.842-.063-17.652 1.724-17.652 1.724z",
    fill: "#e03f89",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.317 157.524s-.811 2.736.608 3.606c1.419.869 15.281.3 16.404.126 1.123-.174 2.823-1.93 2.636-3.922-.188-1.992-1.716-2.182-1.716-2.182z",
    fill: "#cd3884",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.356 158.875c.452 1.596.967 4.159.234 5.724-1.123 2.404-11.524 9.393-14.69 9.994-3.164.585-4.505-4.095-4.022-5.281.078-.206.468-.712 1.076-1.424 4.335-.885 7.812-2.245 9.527-3.068 1.98-.98 4.99-3.384 7.875-5.945z",
    fill: "#e35c9f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.304 159.809c.483 1.233.904 3.068.062 4.728-1.434 2.862-12.49 9.694-14.159 9.552-1.668-.143-1.98-4.033-1.98-4.033l4.444-3.4c2.105-.664 3.774-1.36 4.788-1.85 1.761-.838 4.288-2.8 6.845-4.997z",
    fill: "#d34790",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.297 172.38c.422 3.479 4.912 13.583 6.222 14.912 1.31 1.344 5.255.996 6.455-.98 1.201-1.978.079-6.073-1.886-12.114-1.357-4.143-2.011-6.721-4.258-7.227-3.336-.743-6.985 1.708-6.533 5.408z",
    fill: "#e77cb4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.836 174.244c.92 3.51 4.444 11.718 5.332 12.635.89.902 5.677.585 5.49-2.167-.188-2.751-4.148-12.904-4.99-14.485-.624-1.17-7.423-2.009-5.832 4.017z",
    fill: "#d14a90",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.18 143.592s1.98-1.345 4.818-.475c2.853.87 10.76 5.03 12.163 6.737 1.419 1.692 1.824 3.827.468 6.42-1.357 2.594-4.242 3.18-7.252 1.85-3.025-1.312-11.055-7.036-12.646-8.681-1.59-1.644 1.248-5.14 2.449-5.85z",
    fill: "#e78cbc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.227 147.638s-.67 1.408.562 2.514c1.232 1.124 10.417 6.247 11.82 6.88 1.387.632 3.445.774 4.865-1.25 1.435-2.008 1.419-4.08-.374-5.314-1.763-1.201-16.873-2.83-16.873-2.83z",
    fill: "#d35b9a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.386 127.039c.577 2.056 3.555 3.559 5.302 3.274 1.746-.285 11.71-13.537 12.022-14.992.312-1.47-1.606-5.487-4.756-3.21-1.404.996-13.285 12.43-12.568 14.928z",
    fill: "#d44691",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.609 126.172s1.154 3.036 2.823 2.846c1.668-.19 12.412-11.26 12.646-13.457.234-2.199-3.197-2.294-3.197-2.294z",
    fill: "#cb3685",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.654 73.981c2.12 1.028 4.163 2.452 3.836 4.112-.655 3.321-6.035 11.923-7.423 13.932-1.17 1.708-4.786 2.894-6.767.759.203-.49.405-.996.608-1.47a93.678 93.678 0 0 1 9.746-17.333z",
    fill: "#de6ea9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.72 75.338c2.012 1.028 4.023 2.546 3.384 4.38-1.201 3.385-5.676 10.564-6.611 12.067-.936 1.518-4.289 1.692-5.989.521l.421-.996c2.511-5.851 5.458-11.133 8.795-15.972z",
    fill: "#d14e91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.512 64.42s2.901.236 3.634 2.53c.733 2.293 2.557 12.872 2.666 14.612.125 1.74-1.59 3.432-4.833 3.51-3.244.08-3.946-3.51-4.725-7.654-.78-4.143-2.963-11.402-.967-12.398 1.996-.98 4.225-.6 4.225-.6z",
    fill: "#e66cab",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.23 66.991s1.202-.711 2.012 3.084c.811 3.795 2.433 10.896 2.121 12.477-.312 1.582-3.446 2.752-5.302 1.977-1.855-.775-4.148-15.561-4.148-15.561z",
    fill: "#cb3b87",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.455 43.197s-3.056 2.562-2.199 4.729c.858 2.182 3.29 3.748 7.657 5.85 4.366 2.088 8.28 3.78 10.088 3.432 1.825-.348 3.244-2.925 2.792-5.282-.453-2.356-9.715-5.835-9.715-5.835z",
    fill: "#de70ad",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.646 50.373s2.167.791 2.198 2.515c.047 1.739-1.2 4.253-6.065 2.91-1.731-.475-3.712-1.804-5.677-2.752-3.57-1.724-6.86-3.416-6.782-5.013.109-2.483 4.833-2.151 16.326 2.34z",
    fill: "#d35a9a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.375 36.398s-1.17 1.186-.811 3.242c.343 2.056 2.042 3.59 5.535 3.637 3.477.047 10.993-.19 12.693-.664 1.7-.475 3.088-1.977 3.088-4.729 0-2.767-2.324-3.1-5.957-2.799-3.633.3-14.548 1.313-14.548 1.313z",
    fill: "#e06aac",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.323 38.211s-1.014 2.958 1.076 3.748c2.09.791 8.327.396 12.256.238 3.945-.159 6.409-1.993 5.146-5.045-1.263-3.068-18.478 1.06-18.478 1.06z",
    fill: "#d04c93",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.704 66.108s1.467 1.787.983 3.289c-.483 1.502-5.91 11.75-7.797 13.553-1.871 1.818-7.032-.047-5.879-3.637 1.14-3.606 11.4-14.059 12.693-13.205z",
    fill: "#d0448d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.104 153.337 13.988-.427c4.163-.126 4.397 7.448.218 7.575l-13.987.427c-4.18.11-4.397-7.464-.219-7.575z",
    fill: "#f8af27",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.536 157.827s1.357 1.693 7.953 1.614c6.596-.08 9.901-1.219 10.245-3.195.343-1.977-1.201-2.72-2.2-2.736-.997-.016-13.565.063-15.109.79-1.528.728-1.34 3.069-.889 3.527z",
    fill: "#f9bd3b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.326 155.583c-1.465 2.942 6.877 2.689 8.561 2.625 1.684-.078 8.39.127 8.374-2.324 0-.822-.203-1.755-1.061-1.992-1.465-.396-13.769.331-14.408.395-.64.063-1.232.664-1.466 1.296z",
    fill: "#fdd657",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.25 154.711 13.223-.363c1.871-.048 1.95 2.562.078 2.61l-13.223.363c-1.855.063-1.949-2.562-.078-2.61z",
    fill: "#feedb3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.894 155.319s-.359.838.234.965c.577.11 9.45-.016 9.933-.412.483-.395.545-.965-.484-.965-1.013-.015-8.904.095-9.683.412z",
    fill: "#fef5ce",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.41 157.452s-1.606.806-1.56 1.296c.048.49 1.451.38 2.075-.19.608-.569.187-1.47-.515-1.106z",
    fill: "#f4a427",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.49 166.636 11.383-8.335c3.384-2.482 7.72 3.67 4.335 6.152l-11.383 8.334c-3.383 2.483-7.718-3.669-4.335-6.151z",
    fill: "#f8af27",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.817 171.824s2.058.633 7.484-3.194c5.427-3.827 7.548-6.658 6.752-8.492-.795-1.835-2.479-1.581-3.32-1.028-.843.554-11.228 7.796-12.101 9.267-.873 1.487.577 3.321 1.185 3.447z",
    fill: "#f9bd3b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.254 169.518c.39 3.273 7.173-1.693 8.53-2.704 1.356-1.028 7.032-4.666 5.675-6.706-.451-.68-1.138-1.344-1.964-1.044-1.435.507-11.243 8.129-11.742 8.54-.484.411-.64 1.25-.499 1.914z",
    fill: "#fdd657",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.376 167.69 10.775-7.844c1.528-1.106 3.025 1.013 1.497 2.12l-10.775 7.843c-1.528 1.108-3.025-1.011-1.497-2.119z",
    fill: "#feedb3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.236 167.823s.172.902.718.665c.545-.238 7.827-5.409 8.014-6.01.187-.6-.077-1.107-.935-.522-.826.585-7.313 5.156-7.797 5.867z",
    fill: "#fef5ce",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.439 161.34s-.889 1.582-.577 1.977c.296.395 1.403-.522 1.606-1.344.202-.838-.655-1.345-1.03-.632z",
    fill: "#f4a427",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.34 201.343-12.647-6.152c-3.758-1.835-.577-8.666 3.197-6.832l12.646 6.152c3.774 1.818.577 8.666-3.197 6.832z",
    fill: "#f8af27",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.625 198.546s-.437-2.135-6.347-5.14c-5.894-3.004-9.356-3.527-10.541-1.93-1.2 1.598-.156 2.974.733 3.464.889.49 12.1 6.279 13.784 6.341 1.684.048 2.558-2.135 2.37-2.735z",
    fill: "#f9bd3b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.917 200.157c2.62-1.929-4.912-5.598-6.44-6.325-1.529-.728-7.407-4.033-8.498-1.834-.36.727-.609 1.66.046 2.261 1.138 1.044 12.397 6.12 12.99 6.373.607.237 1.403-.016 1.902-.475z",
    fill: "#fdd657",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.825 200.05-11.928-5.85c-1.684-.823-.593-3.195 1.09-2.373l11.93 5.851c1.684.823.592 3.194-1.092 2.373z",
    fill: "#feedb3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.505 199.212s.687-.601.219-.965c-.468-.38-8.42-4.396-9.03-4.27-.607.127-.903.601 0 1.076.921.49 7.985 4.08 8.811 4.159z",
    fill: "#fef5ce",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.579 190.525s1.794.03 1.98-.428c.188-.458-1.122-1.012-1.933-.79-.81.221-.842 1.233-.047 1.218z",
    fill: "#f4a427",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.122 170.736 4.288 13.6c1.279 4.049 8.343 1.724 7.064-2.325l-4.288-13.6c-1.279-4.033-8.342-1.724-7.064 2.325z",
    fill: "#f8af27",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.413 166.763s2.012.728 4.148 7.1c2.137 6.374 2.184 9.932.483 10.928-1.699.996-2.915-.237-3.274-1.202-.359-.964-4.49-13.078-4.32-14.786.157-1.708 2.402-2.308 2.963-2.04z",
    fill: "#f9bd3b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.632 168.284c2.23-2.388 4.787 5.709 5.286 7.354.483 1.644 2.931 8.018.655 8.84-.764.268-1.684.395-2.183-.348-.858-1.281-4.288-13.347-4.444-13.995-.187-.633.171-1.408.686-1.851z",
    fill: "#fdd657",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.46 170.421 4.086 12.841c.576 1.819 3.025 1.028 2.447-.79l-4.085-12.841c-.577-1.819-3.025-1.013-2.448.79z",
    fill: "#feedb3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.219 170.845s.67-.617.966-.095c.297.521 3.15 9.11 2.947 9.694-.202.6-.717.838-1.06-.142-.343-.981-2.885-8.603-2.853-9.457z",
    fill: "#fef5ce",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.061 184.078s.202-1.82.686-1.946c.468-.126.826 1.265.515 2.057-.344.79-1.326.68-1.201-.111z",
    fill: "#f4a427",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.17 68.627-6.69 12.557c-1.996 3.748-8.514.126-6.518-3.622l6.69-12.557c1.995-3.747 8.514-.126 6.517 3.622z",
    fill: "#f8af27",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.66 64.084s-2.12.348-5.379 6.199c-3.243 5.85-3.945 9.346-2.448 10.642 1.497 1.298 2.916.317 3.43-.569.515-.87 6.784-12.003 6.94-13.71.156-1.708-1.934-2.72-2.542-2.562z",
    fill: "#f9bd3b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.149 65.917c-1.746-2.767-5.739 4.713-6.518 6.23-.78 1.52-4.335 7.339-2.245 8.556.701.412 1.59.712 2.214.063 1.076-1.09 6.642-12.302 6.923-12.904.265-.585.047-1.423-.374-1.945z",
    fill: "#fdd657",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.916 68.049-6.346 11.844c-.904 1.677-3.15.428-2.261-1.233l6.346-11.844c.905-1.693 3.165-.444 2.261 1.233z",
    fill: "#feedb3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.088 68.327s-.545-.727-.935-.284c-.39.458-4.74 8.35-4.647 8.966.094.632.545.964 1.06.063.515-.885 4.398-7.89 4.522-8.745z",
    fill: "#fef5ce",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.974 80.045s.124-1.818-.312-2.04c-.436-.205-1.045 1.091-.873 1.93.171.822 1.154.901 1.185.11z",
    fill: "#f4a427",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.798 34.087 14.002-.427c4.163-.126 4.397 7.448.218 7.575l-14.003.427c-4.163.126-4.38-7.448-.217-7.575z",
    fill: "#f8af27",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.22 38.57s1.357 1.693 7.953 1.614c6.596-.08 9.901-1.234 10.245-3.195.343-1.976-1.2-2.72-2.199-2.736-.998-.015-13.566.064-15.11.791-1.528.728-1.325 3.068-.888 3.527z",
    fill: "#f9bd3b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.031 36.35c-1.466 2.94 6.877 2.688 8.56 2.609 1.685-.08 8.39.142 8.375-2.325 0-.822-.204-1.755-1.061-1.992-1.482-.396-13.769.332-14.408.395-.64.063-1.248.68-1.466 1.312z",
    fill: "#fdd657",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.935 35.482 13.223-.364c1.872-.047 1.95 2.562.078 2.61l-13.223.363c-1.856.048-1.934-2.562-.078-2.609z",
    fill: "#feedb3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.598 36.067s-.359.854.234.965c.578.11 9.45-.016 9.933-.411.483-.395.546-.965-.483-.965s-8.92.095-9.684.411z",
    fill: "#fef5ce",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.101 38.215s-1.606.807-1.56 1.297c.048.49 1.451.364 2.075-.19.608-.57.171-1.47-.515-1.107z",
    fill: "#f4a427",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.394 150.048 12.677 6.073c3.774 1.818 6.94-5.045 3.166-6.864l-12.678-6.072c-3.774-1.803-6.939 5.06-3.165 6.863z",
    fill: "#f8af27",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.781 144.895s1.903-1.012 7.922 1.739c6.019 2.752 8.607 5.14 8.155 7.1-.452 1.946-2.168 2.01-3.088 1.614-.935-.395-12.427-5.567-13.55-6.863-1.123-1.281-.015-3.353.561-3.59z",
    fill: "#f9bd3b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.64 147.265c-.202-3.289 7.36.333 8.873 1.075 1.513.76 7.75 3.29 6.783 5.55-.327.745-.873 1.52-1.747 1.393-1.497-.237-12.505-5.899-13.067-6.215-.561-.316-.872-1.123-.842-1.803z",
    fill: "#fdd657",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.065 148.845 11.99 5.71c1.7.806 2.792-1.55 1.092-2.373l-11.99-5.709c-1.685-.806-2.777 1.566-1.092 2.372z",
    fill: "#feedb3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9 148.563s.016-.917.592-.79c.578.126 8.67 3.859 8.951 4.412.296.553.125 1.107-.827.696-.935-.412-8.14-3.717-8.716-4.318z",
    fill: "#fef5ce",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.05 152.481s-1.155-1.391-.936-1.835c.234-.442 1.48.254 1.824 1.029.343.774-.405 1.439-.888.806z",
    fill: "#f4a427",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.129 112.029-9.543 10.453c-2.854 3.115 2.588 8.287 5.426 5.171l9.559-10.453c2.822-3.115-2.604-8.27-5.442-5.171z",
    fill: "#f8af27",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.139 113.024s.359 2.15-4.054 7.164c-4.413 4.997-7.438 6.784-9.122 5.74-1.684-1.044-1.216-2.72-.562-3.495.655-.79 8.998-10.374 10.557-11.054 1.528-.696 3.134 1.012 3.18 1.645z",
    fill: "#f9bd3b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.962 112.174c3.134.822-2.558 7.037-3.727 8.287-1.17 1.233-5.442 6.53-7.25 4.886-.593-.538-1.155-1.312-.765-2.12.686-1.391 9.34-10.326 9.808-10.784.468-.459 1.31-.523 1.934-.27z",
    fill: "#fdd657",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.048 113.062-8.997 9.9c-1.279 1.392.592 3.178 1.87 1.787l8.998-9.9c1.263-1.391-.608-3.178-1.87-1.787z",
    fill: "#feedb3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.038 113.963s.858.3.562.822c-.296.522-6.253 7.243-6.861 7.338-.608.111-1.076-.221-.39-1.012.67-.79 5.956-6.769 6.69-7.148z",
    fill: "#fef5ce",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.064 126.504s1.653-.696 1.996-.348c.343.348-.686 1.36-1.512 1.455-.843.095-1.217-.823-.484-1.107z",
    fill: "#f4a427",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.707 75.137 45.69 87.504c-2.09 3.685 4.335 7.48 6.424 3.795l7.017-12.366c2.09-3.685-4.335-7.48-6.424-3.796z",
    fill: "#f8af27",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8 74.968s.826 2.025-2.37 7.907c-3.197 5.883-5.754 8.302-7.626 7.686-1.87-.633-1.777-2.372-1.325-3.29.467-.917 6.502-12.16 7.859-13.189 1.34-1.011 3.274.285 3.462.886z",
    fill: "#f9bd3b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.487 74.63c3.228.078-.95 7.447-1.809 8.918-.857 1.47-3.867 7.606-5.987 6.42-.702-.395-1.42-1.027-1.201-1.897.359-1.502 6.83-12.209 7.173-12.746.359-.554 1.17-.79 1.824-.696z",
    fill: "#fdd657",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.831 75.924-6.596 11.703c-.936 1.66 1.279 2.972 2.214 1.312l6.596-11.702c.936-1.645-1.278-2.958-2.214-1.313z",
    fill: "#feedb3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.03 76.797s.889.095.717.664c-.172.586-4.507 8.477-5.083 8.73-.577.253-1.092.031-.608-.886.499-.917 4.335-7.954 4.974-8.508z",
    fill: "#fef5ce",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.984 90.838s1.466-1.059 1.871-.79c.406.269-.358 1.486-1.154 1.755-.795.3-1.372-.506-.717-.965z",
    fill: "#f4a427",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.816 67.88 2.947 13.963c.873 4.16 8.14 2.562 7.266-1.597l-2.947-13.964c-.888-4.159-8.155-2.561-7.266 1.598z",
    fill: "#f8af27",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.448 64.26s1.934.932 3.447 7.48c1.497 6.546 1.2 10.104-.593 10.91-1.793.823-2.885-.537-3.134-1.517-.266-.997-3.197-13.458-2.854-15.15.328-1.676 2.604-2.056 3.134-1.724z",
    fill: "#f9bd3b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.514 65.586c2.448-2.15 4.21 6.167 4.537 7.86.328 1.676 2.137 8.286-.218 8.855-.78.19-1.716.222-2.152-.569-.717-1.36-2.979-13.726-3.072-14.374-.078-.649.359-1.393.905-1.772z",
    fill: "#fdd657",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.146 67.696 2.822 13.189c.406 1.866 2.9 1.312 2.51-.538L91.657 67.16c-.405-1.867-2.9-1.313-2.51.537z",
    fill: "#feedb3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.888 68.214s.717-.554.967 0c.25.553 2.245 9.378 1.98 9.947-.265.569-.795.775-1.044-.253-.234-1.013-2.028-8.857-1.903-9.694z",
    fill: "#fef5ce",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.388 82.068s.39-1.786.857-1.865c.484-.08.702 1.344.312 2.103-.39.759-1.357.537-1.17-.238z",
    fill: "#f4a427",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.907 49.249 12.506 6.436c3.727 1.913 7.064-4.855 3.337-6.768l-12.506-6.42c-3.711-1.93-7.064 4.838-3.337 6.752z",
    fill: "#f8af27",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.425 44.06s1.934-.949 7.875 1.977c5.94 2.91 8.467 5.376 7.952 7.321-.498 1.946-2.214 1.946-3.134 1.534-.92-.41-12.287-5.914-13.363-7.242-1.06-1.329.093-3.369.67-3.59z",
    fill: "#f9bd3b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.214 46.434c-.11-3.29 7.344.537 8.841 1.328 1.497.79 7.657 3.495 6.627 5.725-.342.743-.904 1.502-1.777 1.344-1.497-.284-12.334-6.247-12.896-6.578-.546-.333-.842-1.14-.795-1.82z",
    fill: "#fdd657",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.61 48.046 11.835 6.04c1.668.854 2.838-1.486 1.153-2.324l-11.835-6.041c-1.668-.854-2.822 1.471-1.154 2.325z",
    fill: "#feedb3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.446 47.798s.046-.917.608-.774c.576.142 8.56 4.095 8.825 4.664.281.57.094 1.108-.842.665-.904-.427-8.015-3.922-8.591-4.555z",
    fill: "#fef5ce",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.473 52.11s-1.123-1.424-.873-1.85c.234-.427 1.466.284 1.793 1.075.327.774-.436 1.407-.92.774z",
    fill: "#f4a427",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRussiaOstatkiSladki);
export default __webpack_public_path__ + "static/media/russia_ostatki_sladki.533481dd391f53036dced1aef794cfc2.svg";
export { ForwardRef as ReactComponent };